import { DetailsHeader, DetailsList, Selection, DetailsListLayoutMode, DetailsRow, IColumn, IDetailsHeaderProps, IDetailsHeaderStyles, IDetailsRowProps, IRenderFunction, ProgressIndicator, SelectionMode, Stack, useTheme, IDetailsColumnStyles, MessageBar, IconButton, Icon, Link, ActionButton } from '@fluentui/react';
import * as React from 'react';
import { IUserListItem } from '../../../../../Models/Admin/IUserListItem';
import { IEventTeacherItem } from '../../../../../Models/Event/IEventTeacherItem';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';

interface ITeachersListViewProps {
    isLoading: boolean;
    items: IEventTeacherItem[]
    selectItem?: (item: IEventTeacherItem) => void;
    statusMessage?: IStatusMessage;
    addNewTeacher: () => void;
    updateTeacher: (teacher:IEventTeacherItem) => void;
    deleteTeacher: (teacherId: number) => void;
}


export const TeachersListView: React.FunctionComponent<ITeachersListViewProps> = (props) => {
    const [columns, setColumns] = React.useState<IColumn[]>([]);
    const [selected, setSelected] = React.useState<IEventTeacherItem[]>([]);

    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IEventTeacherItem[];
            setSelected(selected);
        },
        selectionMode: SelectionMode.single
    }));

    React.useEffect(() => {
        buildColumns(props.items);
    }, [props.items])

    React.useEffect(() => {
        if (selected.length > 0) {
            props.selectItem && props.selectItem(selected[0]);
        }
    }, [selected])

    const theme = useTheme();

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }
    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }


    const buildColumns = (items: IEventTeacherItem[]) => {
        const _columns: IColumn[] = [
            { key: 'firstname', isCollapsible: true, name: 'Jméno', fieldName: 'firstname', minWidth: 100, maxWidth: 200, isResizable: true, styles: headerStyle },
            { key: 'lastname', name: 'Příjmení', fieldName: 'lastname', minWidth: 100, maxWidth: 400, isResizable: true, styles: headerStyle },
            { key: 'payment', name: 'Platba', fieldName: 'payment', minWidth: 60, maxWidth: 90, isResizable: true, styles: headerStyle },
            { key: 'mainTeacher', name: 'Hlavní', fieldName: 'mainTeacher', minWidth: 60, maxWidth: 60, isResizable: true, styles: headerStyle, isIconOnly:true },
            { key: 'deleteButton', name: "delete", minWidth: 50, isIconOnly: true },
        ];
        setColumns(_columns);
    }

   

    const renderItemColumn = (item: IEventTeacherItem, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IEventTeacherItem];
            switch (column.key) {
                
                case 'mainTeacher':
                    return <div>{item.mainTeacher ? <Icon styles={{ root: { paddingTop: 3 } }} iconName="PartyLeader" /> : null}</div>
                case 'firstname':
                    return <div><Link styles={{ root: { paddingTop: 2 } }}  title={fieldContent as string} onClick={() => { props.updateTeacher(item) }}>{fieldContent as string}</Link></div>;
                case 'deleteButton':
                    return <div><Link title={fieldContent as string} onClick={() => { props.deleteTeacher(item.id) }}><Icon styles={{ root: { fontSize: 16  } }} iconName="Delete" /></Link ></div>;
                default:
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }



    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }
    const onRenderRow: IRenderFunction<IDetailsRowProps> = (props: any, defaultRender: any) => {
        return (<div key={props.item.key} data-selection-toggle="false" data-selection-touch-invoke="false" data-selection-disabled={true}>
            <DetailsRow {...props} onClick={(ev?: any) => {
                if (ev.target.classList.contains('ms-Check-check')) {
                    selectionState.setKeySelected(props?.item.key, !selectionState.isKeySelected(props?.item.key), false);
                }
            }} />
        </div>)
    }


    return (<Stack><Stack styles={{ root: { height: 10 } }}>
        {props.isLoading ? <ProgressIndicator /> : null}
    </Stack>
        <Stack>
            <ActionButton iconProps={{ iconName: "Add" }} onClick={props.addNewTeacher}>Přidat lektora</ActionButton>
        </Stack>
        <DetailsList
            items={props.items}
            columns={columns}
            setKey="set"
            onRenderDetailsHeader={onRenderDetailsHeader}
            selectionMode={SelectionMode.single}
            layoutMode={DetailsListLayoutMode.justified}
            onRenderItemColumn={renderItemColumn}
            selection={selectionState}
            selectionPreservedOnEmptyClick={false}
            ariaLabelForSelectionColumn="Výběr lektora"
            ariaLabelForSelectAllCheckbox="Výběr lektora"
            checkButtonAriaLabel="Vyber řádek"
            onRenderRow={onRenderRow}
            onItemInvoked={props.selectItem} />

        {props.statusMessage ? <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
    </Stack>)
}
